import { useRef } from "react";
import { IoMdSearch } from "react-icons/io";
import GoogleMap from ".";
import MapLabeledInput from "./MapLabeledInput";

const SiteAddress = ({ onPlaceSelect, position, setPosition }) => {
    const siteRef = useRef(null);
    return (
        <div>
            <GoogleMap
                position={position}
                setPosition={setPosition}
                onPlaceSelect={(place) => {
                    onPlaceSelect(place, siteRef?.current?.value);
                }}
                className={"mb-2"}
                autocompleteInput={
                    <MapLabeledInput
                        placeholder="Enter Your Location"
                        label="Search Address"
                        name="address"
                        required
                        ref={siteRef}
                        icon={<IoMdSearch />}
                        iconWrapperClass="text-primary"
                    />
                }
            />
        </div>
    );
};

export default SiteAddress;
